// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-textError-H_F7H {
	color: #d43242;
}

.common-noBackground-IoE6K {
	background-color: transparent !important;
}

.common-avatarImage-YaAw_ {
	display: grid;
	grid-template-columns: 80px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 20px;
}

.common-imageSection-nS8Nh {
	display: grid;
	grid-template-columns: 56px auto;
}

.common-textSection-OZRgn {
	margin-left: 20px;
}

.common-profileAvatar-CBm3n {
	border-radius: 50%;
}

.common-profileAvatarLink-czwwI {
	border: 2px solid var(--common-link-color);
	border-radius: 50%;
	display: inline-block;
	padding: 5px;
	background-color: transparent;
}

.common-reviewStarSection-_sSMe {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}

.common-dotSection-KChky {
	position: relative;
	padding-left: 14px;
}

.common-dotSection-KChky::before {
	content: '';
	position: absolute;
	top: 8px;
	left: 5px;
	width: 4px;
	height: 4px;
	background-color: var(--common-text-color);
	border-radius: 100%;
}

.common-starImageMargin-gDofe {
	margin-right: 3px;
}

.common-reviewCountFlex-LVrMU {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/common.css"],"names":[],"mappings":"AAAA;CACC,cAAc;AACf;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,WAAW;CACX,0CAA0C;CAC1C,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAkB;KAAlB,sBAAkB;SAAlB;AACD","sourcesContent":[".textError {\n\tcolor: #d43242;\n}\n\n.noBackground {\n\tbackground-color: transparent !important;\n}\n\n.avatarImage {\n\tdisplay: grid;\n\tgrid-template-columns: 80px auto;\n\talign-items: center;\n\tgap: 20px;\n}\n\n.imageSection {\n\tdisplay: grid;\n\tgrid-template-columns: 56px auto;\n}\n\n.textSection {\n\tmargin-left: 20px;\n}\n\n.profileAvatar {\n\tborder-radius: 50%;\n}\n\n.profileAvatarLink {\n\tborder: 2px solid var(--common-link-color);\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tbackground-color: transparent;\n}\n\n.reviewStarSection {\n\tdisplay: flex;\n\talign-items: baseline;\n}\n\n.dotSection {\n\tposition: relative;\n\tpadding-left: 14px;\n}\n\n.dotSection::before {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 8px;\n\tleft: 5px;\n\twidth: 4px;\n\theight: 4px;\n\tbackground-color: var(--common-text-color);\n\tborder-radius: 100%;\n}\n\n.starImageMargin {\n\tmargin-right: 3px;\n}\n\n.reviewCountFlex {\n\tdisplay: flex;\n\talign-items: center\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textError": `common-textError-H_F7H`,
	"noBackground": `common-noBackground-IoE6K`,
	"avatarImage": `common-avatarImage-YaAw_`,
	"imageSection": `common-imageSection-nS8Nh`,
	"textSection": `common-textSection-OZRgn`,
	"profileAvatar": `common-profileAvatar-CBm3n`,
	"profileAvatarLink": `common-profileAvatarLink-czwwI`,
	"reviewStarSection": `common-reviewStarSection-_sSMe`,
	"dotSection": `common-dotSection-KChky`,
	"starImageMargin": `common-starImageMargin-gDofe`,
	"reviewCountFlex": `common-reviewCountFlex-LVrMU`
};
module.exports = ___CSS_LOADER_EXPORT___;
